__turbopack_context__.v({
  "bcard": "brand-module__Z9lR-G__bcard",
  "bcardImg": "brand-module__Z9lR-G__bcardImg",
  "bcardIn": "brand-module__Z9lR-G__bcardIn",
  "bcardInfo": "brand-module__Z9lR-G__bcardInfo",
  "bcardLogo": "brand-module__Z9lR-G__bcardLogo",
  "bcardName": "brand-module__Z9lR-G__bcardName",
  "bcardOverlay": "brand-module__Z9lR-G__bcardOverlay",
  "bcardShop": "brand-module__Z9lR-G__bcardShop",
  "bcardVerified": "brand-module__Z9lR-G__bcardVerified",
  "bcardWm": "brand-module__Z9lR-G__bcardWm",
  "brandGrid": "brand-module__Z9lR-G__brandGrid",
  "brandsFooter": "brand-module__Z9lR-G__brandsFooter",
  "brandsInner": "brand-module__Z9lR-G__brandsInner",
  "brandsSection": "brand-module__Z9lR-G__brandsSection",
  "chip": "brand-module__Z9lR-G__chip",
  "chipImg": "brand-module__Z9lR-G__chipImg",
  "chipIn": "brand-module__Z9lR-G__chipIn",
  "chipLogo": "brand-module__Z9lR-G__chipLogo",
  "chipName": "brand-module__Z9lR-G__chipName",
  "ctaPrimary": "brand-module__Z9lR-G__ctaPrimary",
  "ctaSecondary": "brand-module__Z9lR-G__ctaSecondary",
  "footerBtn": "brand-module__Z9lR-G__footerBtn",
  "hero": "brand-module__Z9lR-G__hero",
  "heroBigNum": "brand-module__Z9lR-G__heroBigNum",
  "heroCanvas": "brand-module__Z9lR-G__heroCanvas",
  "heroChips": "brand-module__Z9lR-G__heroChips",
  "heroContent": "brand-module__Z9lR-G__heroContent",
  "heroCtas": "brand-module__Z9lR-G__heroCtas",
  "heroCut": "brand-module__Z9lR-G__heroCut",
  "heroEyebrow": "brand-module__Z9lR-G__heroEyebrow",
  "heroLeft": "brand-module__Z9lR-G__heroLeft",
  "heroPill": "brand-module__Z9lR-G__heroPill",
  "heroPills": "brand-module__Z9lR-G__heroPills",
  "heroRight": "brand-module__Z9lR-G__heroRight",
  "heroSub": "brand-module__Z9lR-G__heroSub",
  "heroTitle": "brand-module__Z9lR-G__heroTitle",
  "heroTitleEm": "brand-module__Z9lR-G__heroTitleEm",
  "labelLine": "brand-module__Z9lR-G__labelLine",
  "labelText": "brand-module__Z9lR-G__labelText",
  "numLabel": "brand-module__Z9lR-G__numLabel",
  "numValue": "brand-module__Z9lR-G__numValue",
  "sectionLabel": "brand-module__Z9lR-G__sectionLabel",
  "wrap": "brand-module__Z9lR-G__wrap",
});
